<template>
    <div id="tablePrint">
        <b-table
            show-empty
            responsive
            :items="data.commission"
            :fields="fields"
            :per-page="search.perPage"
            class="scroll-bar-pop text-center"
            empty-text="ไม่มีข้อมูล"
            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
        >
            <template slot="index" slot-scope="data">{{ getOverAllIndex( data.index ) }}</template>
            <template slot="card_id" slot-scope="data">{{ (data.item.user_details != null) ? data.item.user_details.card_id : '-' }}</template>
            <template slot="status_resgister" slot-scope="data">
                <b-badge :variant="statusCommission( data.item.user_details != null ? data.item.user_details.status: '' ).color +' status_register'" >
                    {{ statusCommission( data.item.user_details != null ? data.item.user_details.status: '' ).status }}
                </b-badge>
            </template>
            <template slot="created_at" slot-scope="data">{{data.item.user_details?(data.item.user_details.created_at || '-'):'-'}}</template>
            <template slot="date_time_confirm" slot-scope="data">{{data.item.user_details?(data.item.user_details.date_time_confirm || '-'):'-'}}</template>
            <template slot="document_approved" slot-scope="data">{{data.item.user_details?(data.item.user_details.document_approved || '-'):'-'}}</template>
            <template slot="under_by" slot-scope="data">{{data.item.under_by.under_by}}</template>
            <template slot="manage" slot-scope="data">
                <button 
                    class="btn btn-sm btn-primary px-3" 
                    :disabled="handleBtnInformation( data.item.user_details )"
                    @click="goToVerifyPage( data.item.user_details.id )"
                    v-if="data.item.user_details != null"
                >
                    <i class="fas fa-search"></i> ดูข้อมูลยืนยันตัวตน
                </button>
                <button class="btn btn-sm btn-primary px-3" v-else @click="$emit('openFormCreate' , data.item.id)">
                    <i class="fas fa-edit"></i> ยืนยันตัวตน
                </button>
            </template>
        </b-table>
        <div class="mt-3">
            <b-pagination 
                :total-rows="data.totalItem"
                :current-page="search.page"
                :per-page="search.perPage"
                :value="search.page" 
                @input="changePage"
                align="right">
            </b-pagination>
        </div>
    </div>
</template>

<script>
import { statusCommission } from "@/plugins/statusCommission.js";
export default {
    props:{
        search: Object ,
        data: Object , 
        fields: Array
    },
    data() {
        return {
            statusCommission: statusCommission,
        }
    },
    methods:{

        handleBtnInformation( status ){

            if( status == null ) return true

            return false

        },
        goToVerifyPage( id ){

            let routeData = this.$router.resolve({ path: `/verify/${id}` })
            window.open(routeData.href, '_blank');

        },
        changePage(i){
            if (this.search.page == i) return;
            this.search.page = i
            this.$emit('getCommission');
        },
        getOverAllIndex(index){
            return ( this.search.page * 50 ) - 50 + index + 1
        },
        showSuccessModal(msgBody) {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "SUCCESS",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            okTitle: "ตกลง",
            contentClass: "modal-success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
        showErrorModal(msgBody , OkmsgTitle = "ลองอีกครั้ง") {
            this.$bvModal.msgBoxOk(msgBody, {
            title: "ERROR",
            size: "sm",
            buttonSize: "sm",
            okVariant: "danger",
            okTitle: OkmsgTitle,
            contentClass: "modal-errors",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true
            });
        },
    },
}
</script>

<style lang="scss" scoped>

.status_register{
    color: #212529;
    font-size: 1.1rem;
    width: 100%;
}

</style>